import { Card } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { CheckCircle2, Circle, Clock } from "lucide-react";

interface ReviewAgendaTabProps {
  data: any;
}

export function ReviewAgendaTab({ data }: ReviewAgendaTabProps) {
  if (!data.agenda_items || data.agenda_items.length === 0) {
    return (
      <Card className="p-12 text-center">
        <Circle className="h-12 w-12 mx-auto mb-3 text-muted-foreground/50" />
        <p className="text-muted-foreground">No agenda items recorded</p>
      </Card>
    );
  }

  return (
    <div className="space-y-4">
      {data.agenda_items.map((item: any, index: number) => (
        <Card key={index} className="p-6">
          <div className="flex items-start gap-4">
            <div className="flex items-center gap-2 flex-shrink-0">
              <div className="h-8 w-8 rounded-full bg-primary/10 flex items-center justify-center font-semibold">
                {index + 1}
              </div>
              {item.completed && (
                <CheckCircle2 className="h-5 w-5 text-green-600" />
              )}
            </div>

            <div className="flex-1 space-y-3">
              <div>
                <h4 className="font-semibold text-lg">{item.title}</h4>
                {item.description && (
                  <p className="text-sm text-muted-foreground mt-1">{item.description}</p>
                )}
              </div>

              <div className="flex flex-wrap gap-3 text-sm">
                {item.presenter && (
                  <Badge variant="outline">
                    Presenter: {item.presenter}
                  </Badge>
                )}
                {item.time_allocated && (
                  <Badge variant="outline">
                    <Clock className="h-3 w-3 mr-1" />
                    {item.time_allocated}
                  </Badge>
                )}
                <Badge variant={item.completed ? "default" : "secondary"}>
                  {item.completed ? "Completed" : "Not Completed"}
                </Badge>
              </div>

              {item.discussion_notes && (
                <div className="mt-3 p-3 bg-muted rounded-lg">
                  <p className="text-sm font-medium mb-1">Discussion Notes:</p>
                  <p className="text-sm text-muted-foreground whitespace-pre-wrap">
                    {item.discussion_notes}
                  </p>
                </div>
              )}
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
}
